import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import WebsiteBuilder from '../../components/WebsiteBuilder';
import WebsiteViewer from '../../components/WebsiteViewer';
import { useAuth } from '../../contexts/AuthContext';
import { isAdminEmail } from '../../features/auth/authPolicy';
import { ROUTE_PATHS } from './routePaths';

export function RequireAuth({ children }) {
  const { currentUser, validateUserSession } = useAuth();

  if (!currentUser || !validateUserSession(currentUser)) {
    return <Navigate to={ROUTE_PATHS.login} replace />;
  }

  return children;
}

export function RequireAdmin({ children }) {
  const { currentUser, isAdmin, validateUserSession } = useAuth();

  if (!currentUser) {
    return <Navigate to={ROUTE_PATHS.login} replace />;
  }

  if (!validateUserSession(currentUser)) {
    return <Navigate to={ROUTE_PATHS.login} replace />;
  }

  if (!isAdmin || !isAdminEmail(currentUser.email)) {
    return <Navigate to={ROUTE_PATHS.dashboard} replace />;
  }

  return children;
}

export function RedirectAuthenticatedUser({ children }) {
  const { currentUser, isAdmin } = useAuth();

  if (!currentUser) {
    return children;
  }

  return (
    <Navigate
      to={isAdmin ? ROUTE_PATHS.admin : ROUTE_PATHS.dashboard}
      replace
    />
  );
}

export function WebsiteBuilderRoute() {
  const { currentUser, hasAccess } = useAuth();
  const { websiteId } = useParams();

  if (websiteId && !hasAccess(currentUser?.uid)) {
    return <Navigate to={ROUTE_PATHS.dashboard} replace />;
  }

  return <WebsiteBuilder userId={currentUser?.uid} />;
}

export function WebsiteViewerRoute() {
  const { websiteId } = useParams();

  if (!websiteId) {
    return <Navigate to={ROUTE_PATHS.home} replace />;
  }

  return <WebsiteViewer />;
}

